<template>
  <div class="modify_password_cla">
    <el-dialog
      :title="$t('account.modifyPwd')"
      :modal-append-to-body="appendBody"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      width="45%"
      @close="cancle()"
      :showClose="showClose"
      :showCancelButton="showCancelButton"
      :closeOnPressEscape="closeOnPressEscape"
    >
      <el-form
        ref="modifyForm"
        :model="modifyForm"
        label-position="right"
        :rules="rules"
        label-width="180px"
      >
        <el-form-item :label="$t('account.account')" prop="loginName">
          <el-row>
            <el-col :span="24">
              <el-input type="text" v-model="modifyForm.loginName" disabled>
              </el-input>
            </el-col>
          </el-row>
        </el-form-item>

        <el-form-item :label="$t('account.oldPwd')" prop="password">
          <el-input
            type="password"
            v-model="modifyForm.password"
            :placeholder="$t('account.oldPwdRequire')"
          ></el-input>
        </el-form-item>

        <el-form-item :label="$t('account.newPwd')" prop="newPassword">
          <el-input
            type="password"
            v-model="modifyForm.newPassword"
            :placeholder="$t('account.newPwdRequire')"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('account.confirmNewPwd')" prop="confirmNewPwd">
          <el-input
            type="password"
            v-model="modifyForm.confirmNewPwd"
            :placeholder="$t('account.confirmNewPwdRequire')"
          ></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="cancle()" v-if="showCancelButton">{{
          $t('common.cancel')
        }}</el-button>
        <el-button type="primary" @click="modifyPwd()">{{
          $t('common.confirm')
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { modifyPwd } from '../../../services/user.js'
export default {
  name: 'ZkModifyPwd',
  data() {
    let modifyForm = {
      loginName: '',
      password: '',
      newPassword: '',
      confirmNewPwd: ''
    }

    let confirmNewPwd = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t('account.confirmNewPwdRequire')))
      } else if (value !== this.modifyForm.newPassword) {
        return callback(new Error(this.$t('account.newNotEqualNew')))
      } else {
        callback()
      }
    }
    let rules = {
      password: [
        {
          required: true,
          message: this.$t('account.oldPwdRequire'),
          trigger: 'blur'
        }
      ],
      newPassword: this.validatorPasswordRule(true),
      confirmNewPwd: [
        { required: true, validator: confirmNewPwd, trigger: 'blur' }
      ]
    }
    return {
      rules,
      modifyForm,
      visible: false
    }
  },
  methods: {
    cancle() {
      this.$emit('close')
    },
    modifyPwd() {
      let self = this
      this.$refs.modifyForm.validate(valid => {
        if (valid) {
          modifyPwd(self.modifyForm)
            .then(data => {
              if (data.code === '00000000') {
                self.$message.success(this.$t('account.modifyPwdSuccess'))
                // debugger
                if (this.redirectLogin) {
                  // 密码太弱 强制修改密码跳转login
                  let t = setTimeout(() => {
                    this.$router.push({ path: '/login' })
                    clearTimeout(t)
                  }, 1000)
                }
                self.modifyForm.loginName = ''
                self.modifyForm.password = ''
                self.modifyForm.newPassword = ''
                self.modifyForm.confirmNewPwd = ''
                self.$emit('close')
              } else {
                self.$message.warning(data.message)
              }
            })
            .catch(data => {
              self.$message.warning(data.message)
            })
        }
      })
    }
  },
  mounted() {
    let loginName =
      window.localStorage.getItem('loginName') ||
      window.sessionStorage.getItem('loginName') ||
      ''
    this.modifyForm.loginName = loginName
  },

  props: {
    redirectLogin: {
      type: Boolean,
      default: false
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    appendBody: {
      type: Boolean,
      default: true
    },
    showClose: {
      type: Boolean,
      default: true
    },
    showCancelButton: {
      type: Boolean,
      default: true
    },
    closeOnPressEscape: {
      type: Boolean,
      default: true
    }
  }
}
</script>
<style lang="less">
.modify_password_cla {
  // .el-form-item {
  //   width: 100%;
  //   .el-form-item__label {
  //     float: left;
  //     width: 180px;
  //   }
  //   .el-form-item__content {
  //     float: left;
  //   }
  // }
}
</style>



// WEBPACK FOOTER //
// src/cdpBase/baseComponents/modifyPwd/src/main.vue